import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.txnTaxDetail')
export class TxnTaxDetail extends AbstractModel {

    @JsonProperty(Number, 'totalTax')
    totalTax: number;
}
